import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBoolVal, hasAccess } from "../../utils";
import Table from "../Common/Table/Table";
import {
  advances,
  Advances as AdvancesType,
  userAdvances,
  UserAdvances,
} from "./../../actions/advances/advances";
import PageHeader from "./../PageHeader";
// import moment from "moment";
import { message, Modal, Typography } from "antd";
import { useHistory, useLocation } from "react-router";
import AddAdvance from "./AddAdvance";
import "./advances.css";
import BaseCurrency from "../Common/BaseCurrency";

const { Title } = Typography;

const Advances = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [totalRecords, setTotalRecords] = React.useState(0);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [advancesData, setAdvancesData] = React.useState([]);
  const [filters, setFilters] = React.useState({});
  const [page, setPage] = React.useState(1);
  const [sortOrder, setSortOrder] = React.useState("asc");

  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );
  const advancesResponse = useSelector((state) => state.advances.advances);
  const userAdvancesResponse = useSelector(
    (state) => state.advances.userAdvances,
  );
  const addUserAdvanceResponse = useSelector(
    (state) => state.advances.addUserAdvance || {},
  );

  const location = useLocation();

  const updateUserAdvanceResponse = useSelector(
    (state) => state.advances.updateUserAdvance || {},
  );

  React.useEffect(() => {
    if (location.state?.createNew) {
      setIsModalVisible(true);
    }
    if (location.state?.filter) {
      handleFilter(location.state?.filter);
    } else {
      getBoolVal(sessionStorage.getItem("is_admin"))
        ? dispatch(advances({}))
        : dispatch(userAdvances({}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const {
      data: {
        response: { advances = [] } = {},
        status = false,
        total_records = 0,
      } = {},
    } = advancesResponse;
    if (status) {
      setAdvancesData([...advances]);
      setTotalRecords(total_records);
      dispatch({
        type: AdvancesType.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advancesResponse]);

  React.useEffect(() => {
    const {
      data: {
        response: { advances = [] } = {},
        status = false,
        total_records = 0,
      } = {},
    } = userAdvancesResponse;
    if (status) {
      setAdvancesData([...advances]);
      setTotalRecords(total_records);
      dispatch({
        type: UserAdvances.RESET,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userAdvancesResponse]);

  React.useEffect(() => {
    const { data: { status = false, message: res_message = "" } = {} } =
      addUserAdvanceResponse;
    if (status) {
      handleCancel();
      dispatch(userAdvances({}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addUserAdvanceResponse]);

  React.useEffect(() => {
    const { data: { status = false, message: res_message = "" } = {} } =
      updateUserAdvanceResponse;
    if (status) {
      handleCancel();
      dispatch(userAdvances({}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateUserAdvanceResponse]);

  const handleSearch = (value) => {
    getBoolVal(sessionStorage.getItem("is_admin"))
      ? dispatch(advances({ ...filters, search_key: value }))
      : dispatch(userAdvances({ ...filters, search_key: value }));
    setFilters({
      ...filters,
      search_key: value,
    });
    setPage(1);
  };

  const handleAddButton = (evt, record) => {
    // handleModal();
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleRowClick = (evt, record) => {
    evt.preventDefault();
    if (record) {
      history.push({
        pathname: `/advance-details/${record.id}`,
        state: { advanceData: record, filter: filters.status },
      });
    }
  };

  const handleFilter = (value) => {
    if (value === "true") {
      getBoolVal(sessionStorage.getItem("is_admin"))
        ? dispatch(advances({}))
        : dispatch(userAdvances({}));
      setFilters({
        ...filters,
        status: "",
      });
    } else {
      getBoolVal(sessionStorage.getItem("is_admin"))
        ? dispatch(advances({ ...filters, status: value }))
        : dispatch(userAdvances({ ...filters, status: value }));

      setFilters({
        ...filters,
        status: value,
      });
    }
    setPage(1);
  };

  const columns = [
    {
      title: "Advance ID",
      dataIndex: "advance_number",
      key: "advance_number",
      render: (text, record) => (
        <div className={`render_common_style status_${record?.status}`}>
          {text}
        </div>
      ),
    },
    {
      title: "Purpose or Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Date and Time",
      dataIndex: "date",
      key: "date",
      // render: (text) => <div>{moment(text).format("DD MMM YYYY")}</div>,
    },
    {
      title: "Recorded By",
      dataIndex: "submitted_by",
      key: "submitted_by",
    },
    {
      title: "Reference",
      dataIndex: "reference_no",
      key: "reference_no",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => (
        <div>
          <BaseCurrency />
          {text}
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <div
          className={`status status_${is_admin ? record?.current_advance_status : text}`}
        >
          {is_admin
            ? record?.current_advance_status?.replace(/_/g, " ")
            : text?.replace(/_/g, " ")}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`Advances`}
          navigation={{
            Home:
              hasAccess("dashboard", "read") || hasAccess("dashboard", "write")
                ? "/dashboard"
                : "",
            Advances: "/advances",
          }}
        />
      </div>
      {isModalVisible && (
        <Modal
          title={
            <Title level={4}>
              New Advance &nbsp;
              <span className="text-small">Enter details and submit</span>
            </Title>
          }
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={[]}
          className="right-alinged-modal"
        >
          <AddAdvance handleCancel={handleCancel} />
        </Modal>
      )}
      <Table
        rowKey="id"
        columns={columns}
        data={advancesData}
        isTopFilter={true}
        placeholder={"Search By Advance ID, Title"}
        handleRowClick={handleRowClick}
        handleSearch={handleSearch}
        handleFilter={handleFilter}
        handleAddButton={handleAddButton}
        dotMenu={
          is_admin
            ? ["amount", "recorded_by", "title"]
            : ["title", "date", "reference", "amount"]
        }
        handleSort={(key) => {
          const newOrder =
            filters.sort_key === key
              ? filters.sort_order === "asc"
                ? "desc"
                : "asc"
              : "asc";
          getBoolVal(sessionStorage.getItem("is_admin"))
            ? dispatch(
                advances({ ...filters, sort_key: key, sort_order: newOrder }),
              )
            : dispatch(
                userAdvances({
                  ...filters,
                  sort_key: key,
                  sort_order: newOrder,
                }),
              );
          setFilters({
            ...filters,
            sort_key: key,
            sort_order: newOrder,
          });
          setSortOrder(newOrder);
          setPage(1);
        }}
        module="Advance"
        is_admin={sessionStorage.getItem("is_admin")}
        activeButton={location?.state?.filter}
        pagination={{
          total: totalRecords || 0,
          current: page,
          showSizeChanger: false,
          onChange: (pagee) => {
            getBoolVal(sessionStorage.getItem("is_admin"))
              ? dispatch(advances({ page: pagee, ...filters }))
              : dispatch(userAdvances({ page: pagee, ...filters }));
            setPage(pagee);
          },
        }}
        className="tableStyled"
        topFilters={
          is_admin
            ? [
                { label: "All Advances", filter: "true" },
                { label: "Pending Approval", filter: "pending_approval" },
                { label: "Recovered", filter: "recovered" },
                { label: "Pending Recovery", filter: "pending_recovery" },

                { label: "Approved", filter: "approved" },
                { label: "Rejected", filter: "rejected" },
                // { label: "More", isMore: true },
              ]
            : [
                { label: "All Advances", filter: "true" },
                { label: "Pending Approval", filter: "pending_approval" },
                { label: "Recovered", filter: "recovered" },
                { label: "Pending Recovery", filter: "pending_recovery" },
                { label: "Approved", filter: "approved" },
                { label: "Rejected", filter: "rejected" },
                { label: "Unsubmitted", filter: "unsubmitted" },
              ]
        }
      />
    </>
  );
};

export default Advances;
